/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HousewareSprayIcon20Solid = forwardRef('HousewareSprayIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.042 1.44a.75.75 0 1 0-.584-1.38L14.5 1.31a.75.75 0 1 0 .584 1.38l2.958-1.25Z" }),
        React.createElement("path", { d: "M3 4v2.199l10-1.516V3.75A1.75 1.75 0 0 0 11.25 2H5a2 2 0 0 0-2 2Z" }),
        React.createElement("path", { d: "M3 15.5V7.463l5-.758v2.167a1 1 0 0 0 .672.945l3.648 1.266A2.5 2.5 0 0 1 14 13.445V15.5a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 3 15.5Z" }),
        React.createElement("path", { d: "M9 8.333v-1.78l2-.302v2.082a1 1 0 1 1-2 0Z" }),
        React.createElement("path", { d: "M15.084 5.31a.75.75 0 1 0-.584 1.38l2.958 1.25a.75.75 0 0 0 .584-1.38l-2.958-1.25Z" }),
        React.createElement("path", { d: "M14.5 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 14.5 4Z" })));
});
